import React, { useCallback, useEffect, useRef, useState } from 'react'
import { ThemeProvider } from 'styled-components'

import useHash from '../../hooks/useHash'
import { transformToREM } from '../../styles'

import Styled from './RecipeAccordionSection.styled'

const RecipeAccordionSection = ({
  className,
  title,
  subtitle,
  children,
  variant,
  headerRight,
  id,
}) => {
  const contentRef = useRef(null)

  const [contentHeight, setContentHeight] = useState('0')
  const handleCollapseClicked = useCallback(() => {
    if (contentRef?.current?.offsetHeight) {
      setContentHeight((h) =>
        h !== '0' ? '0' : transformToREM(contentRef.current.offsetHeight + 24),
      )
    } else {
      setContentHeight((h) => (h !== '0' ? '0' : 'unset'))
    }
  }, [])

  const [hash] = useHash()
  useEffect(() => {
    if (id && hash && hash === `#${id}` && contentHeight === '0') {
      handleCollapseClicked()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash, id])

  return (
    <ThemeProvider theme={{ variant }}>
      <Styled
        className={className}
        {...(id ? { id, 'data-scroll-offset': true } : {})}
      >
        <Styled.header $isOpen={contentHeight !== '0'}>
          <Styled.headerLeft $hasHeaderRight={!!headerRight}>
            <Styled.title>{title}</Styled.title>
            {subtitle ? <Styled.subtitle>{subtitle}</Styled.subtitle> : null}
          </Styled.headerLeft>
          {headerRight ? (
            <Styled.headerRight>{headerRight}</Styled.headerRight>
          ) : null}
          <Styled.chevronButton onClick={handleCollapseClicked}>
            <Styled.chevron
              $isOpen={contentHeight !== '0'}
              name="direction-down-24"
              width={24}
            />
          </Styled.chevronButton>
        </Styled.header>
        <Styled.content style={{ maxHeight: contentHeight }}>
          <Styled.container ref={contentRef}>{children}</Styled.container>
        </Styled.content>
      </Styled>
    </ThemeProvider>
  )
}

RecipeAccordionSection.defaultProps = {
  variant: 'secondary',
}

export default RecipeAccordionSection
